module.exports = __webpack_public_path__ + "img/banner-news.000eaff4.png";